module.exports = __webpack_public_path__ + "img/icon-time4.9fc08f9d.png";